import type { Lang } from '../../types';
import { useApp } from '../../context/AppContext';

const OPTIONS: { value: Lang; label: string }[] = [
  { value: 'en', label: 'EN' },
  { value: 'hi', label: 'हिं' },
];

export function LangToggle() {
  const { lang, setLang } = useApp();
  return (
    <div className="inline-flex rounded-full border border-sc-line bg-white p-0.5" role="group" data-testid="language-toggle">
      {OPTIONS.map((o) => (
        <button
          key={o.value}
          type="button"
          onClick={() => setLang(o.value)}
          data-testid={`language-toggle-${o.value}`}
          aria-pressed={lang === o.value}
          className={`h-9 min-w-[44px] rounded-full px-3 text-sm font-semibold transition-colors duration-200 ${
            lang === o.value ? 'bg-sc-teal text-white' : 'text-slate-600 hover:bg-sc-soft'
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
